// extracted by mini-css-extract-plugin
export var carrierNotice = "_ka-5";
export var carrierNoticePlaceholder = "_ka-6";
export var deliveryRow = "_ka-c";
export var fixedHeight = "_ka-4";
export var freightLogo = "_ka-b";
export var fullWidth = "_ka-3";
export var priceColumn = "_ka-7";
export var radioSelected = "_ka-9";
export var radioUnselected = "_ka-8";
export var selectedOption = "_ka-2";
export var selectedOptionContainer = "_ka-1";
export var selection = "_ka-0";
export var tallSkeletonText = "_ka-a";